export default class Slider {
    constructor(slides, dots, controls) {
        this.slides = slides
        this.dots = dots
        this.controls = controls
        this.slideIndex = 0
        this.intervalID = ''

        this.init()
    }

    init(){
        this.showSlides(this.slideIndex);

        if(this.dots.length > 0) {
            const dotArr = Array.from(this.dots)

            let dot
            for (dot in dotArr) {
                dotArr[dot].addEventListener('click', this.currentSlide.bind(this))
            }
        }

        if (this.controls.length > 0 ){
            this.controls[0].addEventListener('click', this.handleSlideControls.bind(this))
        }


        this.slideAutoPlayer(this.slideIndex +1 , this.slides.length +1)
    }

    slideAutoPlayer(n, max) {
        this.intervalID = window.setInterval(function() {
            if(n === max) {
                n=0;
            }
            if(n < max) {
                this.autoShowSlides(this.slideIndex = n);
                n += 1
            } else {
                window.clearInterval(this.intervalID);
            }
        }.bind(this), 6000)
    }

    handleSlideControls(e) {
        window.clearInterval(this.intervalID)
        const dir= e.target.dataset === "next" ? -1 : 1
        this.plusSlides(dir)
    }

    plusSlides(n) {
        console.log(this.slideIndex, n)
        this.clickShowSlides(this.slideIndex += n)
    }

    currentSlide(e) {
        var n= e.target.dataset.val

        this.slideIndex = n
        this.showSlides(this.slideIndex);
    }

    showSlides(n){
        var i;

        if (n > this.slides.length) {
            this.slideIndex = 0
        }

        for (i = 0; i < this.slides.length; i++) {
            this.slides[i].style.display = "none";
        }

        this.slides[this.slideIndex].style.display = "block";

        if(this.dots.length > 0 ) {
            for (i = 0; i < this.dots.length; i++) {
                this.dots[i].className = this.dots[i].className.replace(" active", "");
            }
            this.dots[this.slideIndex].className += " active";
        }
    }

    clickShowSlides(n){
        var i;

        if (n > this.slides.length) {
            this.slideIndex = 1
        }
        if (n < 1) {
            this.slideIndex = this.slides.length
        }
        for (i = 0; i < this.slides.length; i++) {
            this.slides[i].style.display = "none";
        }
        for (i = 0; i < this.dots.length; i++) {
            this.dots[i].className = this.dots[i].className.replace(" active", "");
        }
        this.slides[this.slideIndex - 1].style.display = "block";

        if(this.dots.length > 0 ) {
            this.dots[this.slideIndex - 1].className += " active";
        }
    }

    autoShowSlides(n){
        var i;

        if (n > this.slides.length) {
            this.slideIndex = 0
        }

        for (i = 0; i < this.slides.length; i++) {
            this.slides[i].style.display = "none";
        }
        for (i = 0; i < this.dots.length; i++) {
            this.dots[i].className = this.dots[i].className.replace(" active", "");
        }
        if (parseInt(this.slideIndex) !== 0 ) {
            this.slides[this.slideIndex - 1].style.display = "block";
            if(this.dots.length > 0 ) {
                this.dots[this.slideIndex - 1].className += " active";
            }
        } else {
            this.slides[this.slideIndex].style.display = "block";
            if(this.dots.length > 0 ) {
                this.dots[this.slideIndex].className += " active";
            }
        }
    }
}